import React from 'react';
import PropTypes from 'prop-types';
import { ImageLazyLoad } from '../../';
import { decodeHTMLEntities } from '../../../utils';
import './styles.scss';

const propTypes = {
  blog: PropTypes.object,
};

class BlogPostResult extends React.Component {
  render() {
    const { blog } = this.props;

    const blogImage = blog.image ? blog.image.replace('http://', 'https://') : '/images/explore-placeholder-16by9.jpg';

    const loaderProps = { style: { height: 190 }, dark: true }
    return (
      <a href={blog.link} className="row search-result-item result-info-box no-gutters blog-post-result">
        <div className="col-md-6">
          <div className="blog-post-hover-info"><div className="u-font-foundation-light abs-center hover-text">Read <br />Blog Post</div></div>
          <ImageLazyLoad src={blogImage} loaderProps={loaderProps} minHeight={190} />
        </div>
        <div className="col-md-6 blog-info">
          <div className="result-text-info">
            <h2 className="blog-post-title">{decodeHTMLEntities(blog.title)}</h2>
          </div>
        </div>
      </a>
    )
  }
}

BlogPostResult.propTypes = propTypes;

export default BlogPostResult;
